import { useEffect, useState } from "react";
import { getStringStorage, saveStorage, STORAGE_USER_LOCATION } from "../services/storage";

export interface IUserLocation {
	latitude?: number;
	longitude?: number;
	accuracy?: number;
}

export function useUserLocation() {
	const [location, setLocation] = useState<IUserLocation | null>(null);

	useEffect(() => {
		const saved = getStringStorage(STORAGE_USER_LOCATION);

		if (saved) {
			setLocation(JSON.parse(saved));
			return;
		};
    
		navigator.geolocation.getCurrentPosition(
			(position) => {
				const loc = {
					latitude: position?.coords?.latitude,
					longitude: position?.coords?.longitude,
					accuracy: position?.coords?.accuracy,
				};

				saveStorage(STORAGE_USER_LOCATION, loc);

				setLocation(loc);
			},
			(error) => {
				console.error(error);
			},
		);
	}, []);

	return location;
}
